@if (widgetFormGroup && customFieldsList) {
  <div
    [formGroup]="typecastAbstractToFormGroup(widgetFormGroup)"
    class="tw-flex tw-gap-5 tw-justify-between"
    [ngClass]="canDisplayTwoColumns ? 'tw-flex-row' : 'tw-flex-col'">
    @for (col of (twoColumnLayoutAllowed ? [1, 2] : [1]); track col; let colIndex = $index) {
      <div class="tw-flex tw-flex-col tw-flex-100"
        [ngClass]="canDisplayTwoColumns && 'tw-max-w-[50%]'"
        >
        @for (field of customFieldsList; track field; let i = $index) {
          @if (!twoColumnLayoutAllowed || i%2 === colIndex) {
            @switch (field.fieldType) {
              <!-- maybe use this for the case when we have list of groups? -->
              @case ('list') {
                <div>
                  @if (!field.hidden) {
                    <gd-field-array-builder
                      [formArrayName]="field.key"
                      [arrayFieldControl]="typecastAbstractToFormArray(getFormFieldForKey(field.key, field.fieldType))"
                      [arrayFieldConfig]="customFieldsList[i]"
                      [hasActionPermission]="hasActionPermission"
                      [usage]="usage"
                      [activeLocale]="activeLocale"
                      [readOnlyMode]="field.readOnly">
                    </gd-field-array-builder>
                  }
                </div>
              }
              @default {
                <div>
                  <div class="group">
                    @if (!field.hidden) {
                      <gd-field-builder
                        [width]="100"
                        [fieldConfig]="field"
                        [fieldControl]="widgetFormGroup.get(field.key)"
                        [hasActionPermission]="hasActionPermission"
                        [isEditingMode]="isEditingMode"
                        [usage]="usage"
                        [activeLocale]="activeLocale"
                        [readOnlyMode]="field.readOnly">
                      </gd-field-builder>
                    }
                  </div>
                </div>
              }
            }
          }
        }
      </div>
    }
  </div>
}
